import { render, staticRenderFns } from "./SectionCustom.vue?vue&type=template&id=619d63b3&scoped=true&"
import script from "./SectionCustom.vue?vue&type=script&lang=js&"
export * from "./SectionCustom.vue?vue&type=script&lang=js&"
import style0 from "./SectionCustom.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SectionCustom.vue?vue&type=style&index=1&id=619d63b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d63b3",
  null
  
)

export default component.exports